





















import lottie from "lottie-web";

export default {
  name: "BaseAnimationWithAudio",
  data: function () {
    return {
      lottie: null,
    };
  },
  props: {
    json: {
      type: Object,
      default: null,
    },
    autoplay: { type: Boolean, default: false },
    paused: {
      type: Boolean,
      required: false,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    audio: {
      type: String,
      default: null,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    fps: {
      type: Number,
      required: true,
    },
  },
  created() {},
  watch: {
    autoplay: function () {
      if (!this.autoplay) {
        this.lottie.goToAndStop(1);
      } else {
        this.lottie.play();
      }
      this.updateAudioMuted();
    },
    paused: function () {
      if (this.paused) {
        this.lottie.pause();
      } else {
        this.lottie.play();
      }
      this.updateAudioMuted();
    },
    json: function () {
      this.updateAnimation();
    },
    muted: function () {
      this.updateAudioMuted();
    },
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: this.$refs.element,
      renderer: "svg",
      loop: this.loop,
      autoplay: this.autoplay,
      animationData: this.json,
    });

    if (this.paused) {
      this.goToAndStop(0);
    } else {
      this.goToAndPlay(0);
    }

    this.lottie.onComplete = () => {
      if (this.audio && this.$refs.music) {
        this.$refs.music.pause();
      }
      this.$emit("end");
    };
    this.lottie.onEnterFrame = () => {
      if (this.audio && this.$refs.music) {
        if (
          this.$refs.music.currentTime >
            this.getCurrentFrame() / this.fps + 0.2 ||
          this.$refs.music.currentTime < this.getCurrentFrame() / this.fps - 0.2
        ) {
          this.$refs.music.currentTime = this.getCurrentFrame() / this.fps;
        }
      }
      this.$emit("timeUpdate");
    };
    this.updateAudioMuted();
  },
  methods: {
    getCurrentFrame() {
      return this.lottie.currentFrame;
    },
    goToAndPlay(time) {
      this.lottie.goToAndPlay(time, false);
      if (this.audio && this.$refs.music) {
        this.$refs.music.play();
      }
      this.updateAudioMuted();
    },
    goToAndStop(time) {
      if (!!time) {
        if (this.audio && this.$refs.music) {
          this.$refs.music.currentTime = time / 1000;
        }
      }
      this.lottie.goToAndStop(time, false);
      if (this.audio && this.$refs.music) {
        this.$refs.music.pause();
      }
      this.updateAudioMuted();
    },
    updateAnimation() {
      const lastFrame = this.getCurrentFrame();

      this.lottie.destroy();
      this.lottie = lottie.loadAnimation({
        container: this.$refs.element,
        renderer: "svg",
        loop: this.loop,
        autoplay: this.autoplay,
        animationData: this.json,
      });
      if (this.paused) {
        this.lottie.goToAndStop(lastFrame, true);
        if (this.audio && this.$refs.music) {
          this.$refs.music.pause();
        }
      } else {
        this.lottie.goToAndPlay(lastFrame, true);
        if (this.audio && this.$refs.music) {
          this.$refs.music.play();
        }
      }

      this.lottie.onComplete = () => {
        if (this.audio && this.$refs.music) {
          this.$refs.music.pause();
        }
        this.$emit("end");
      };
      this.lottie.onEnterFrame = () => {
        if (this.audio && this.$refs.music) {
          if (
            this.$refs.music.currentTime >
              this.getCurrentFrame() / this.fps + 0.2 ||
            this.$refs.music.currentTime <
              this.getCurrentFrame() / this.fps - 0.2
          ) {
            this.$refs.music.currentTime = this.getCurrentFrame() / this.fps;
          }
        }
        this.$emit("timeUpdate");
      };
      this.updateAudioMuted();
    },
    updateAudioMuted() {
      if (this.audio && this.$refs.music) {
        this.$refs.music.muted = this.muted;
      }
    },
  },
};
